<div class="flex global-nav-wrapper items-center" [class.smallSize]="isSmallSize" [class.showPanel]="searchProductStore.showPanelBtn()">
  @if (isSmallSize) {
    <div class="flex justify-between w-full">
      <ng-template *ngTemplateOutlet="logo"></ng-template>
      <ng-template *ngTemplateOutlet="actions"></ng-template>
    </div>
    @if (searchProductStore.showPanelBtn()) {
      <ng-template *ngTemplateOutlet="searchInput"></ng-template>
    }

  } @else {
    <ng-template *ngTemplateOutlet="logo"></ng-template>
    <ng-template *ngTemplateOutlet="searchInput"></ng-template>
    <ng-template *ngTemplateOutlet="actions"></ng-template>
  }

</div>


<ng-template #myFooterBlock>
  <small class="actions flex flex-col">

    <div class="footer">
      <a class="routing" [routerLink]="['',{ outlets: { primary: ['legal-docs', 'PRIVACY'], mainBody: null } },]">Privacy
        Policy</a>
    </div>
    <div class="footer">
      <a [routerLink]="[
          '',
          { outlets: { primary: ['legal-docs', 'TERMS'], mainBody: null } },
        ]" class="routing">Condition of Use</a>
    </div>
    <div class="footer">
      <a class="routing" [routerLink]="[
          '',
          {
            outlets: {
              primary: ['legal-docs', 'ADS_POLICY'],
              mainBody: null,
            },
          },
        ]">Interest-Based Ads Policy</a>
    </div>
  </small>
  <small class="copy-right">© 2025 AmMall Inc. All rights reserved.</small>
</ng-template>

<ng-template #logo>
  <div class="flex items-center gap-6 logo-container" [class.smallSize]="isSmallSize">
    <a class="cursor-pointer" (click)="onExplore()">
      <img class="brand-logo" src="../../../../assets/img/logo/logo_ammall.svg" alt="logo" aria-hidden="true" />
    </a>
    <button *ngIf="!isSmallSize" [class.primary-button-active]="shouldExploreBtnActiveStyle" type="button" (click)="onExplore()">
      Explore
    </button>
  </div>
</ng-template>

<ng-template #searchInput>
  <div class="flex gap-1 items-center search-section flex-grow" [class.smallSize]="isSmallSize">
    <div class="flex search-bar-section gap-3 w-full items-center">
      <span class="material-symbols-outlined" style="color: #9e9e9e; font-size: 21px; align-self: center; ">
        search
      </span>
      <input class="search-bar" type="text" placeholder="Search product" [(ngModel)]="searchValue"
        (focus)="onFocusSearchInput()" />
      @if (searchValue) {
      <span class="material-symbols-outlined cursor-pointer" style="color: #282E38; font-size: 21px;"
        (click)="deleteSearchInput()">close</span>
      }
    </div>

    <!-- filter & sort button -->
    @if (searchProductStore.showPanelBtn()) {
      @if (searchProductStore.showPanel()) {
      <button class="filter-btn" (click)="showHideFilter()" [style]="{ width: '185px','min-width': '150px' }">
        Hide Filter & Sort
      </button>
      } @else {
      <button class="filter-btn" (click)="showHideFilter()" [style]="{ width: '170px', 'min-width': '150px' }">
        <span class="material-symbols-rounded" style="font-size: 17px; color: #282E38;">tune</span>
        <div>Filter & Sort</div>
      </button>
      }
    }

    <p-dialog [(visible)]="showSearchFilter" [position]="'left'" [modal]="true">
      <ng-template pTemplate="headless">
        <amm-search-filter [isSmallSize]="true" (hideFilter)="getFilterEvent($event)"></amm-search-filter>
      </ng-template>
    </p-dialog>

  </div>
</ng-template>

<ng-template #actions>
  <div class="flex items-center function-container" [class.smallSize]="isSmallSize">
    <div class="flex icons">
      <amm-button-with-bage *ngIf="isSmallSize" [iconName]="iconName.search"
        (onButtonClick)="onButtonClick($event)"></amm-button-with-bage>
      <amm-button-with-bage [iconName]="iconName.favorite" iconDesciption="favorites" [isBtnActive]="isFavoritePage"
        (onButtonClick)="onButtonClick($event)"></amm-button-with-bage>
      <amm-button-with-bage *ngIf="!isSmallSize" [iconName]="iconName.orders" iconDesciption="orders" [isBtnActive]="isOrdersPage"
        (onButtonClick)="onButtonClick($event)"></amm-button-with-bage>
      <amm-button-with-bage [iconName]="iconName.shoppingCart" iconDesciption="cart" [isBtnActive]="isShoppingCartPage"
        [counter]="shopInfoStore.shoppingCartCount()" (onButtonClick)="onButtonClick($event)"></amm-button-with-bage>
    </div>

    <!-- Avatar Section/Login Section -->
    @if (authService.isLoggedIn()) {
      <div>
        @if (isSmallSize) {
          <div class="menuBtn flex items-center justify-center" (click)="op.toggle($event)">
            <span class="material-symbols-outlined">menu</span> 
          </div>

        } @else {
          <div class="flex flex-row items-center gap-1 profile-img-warpper cursor-pointer relative"
            (click)="op.toggle($event)">
            @if(messageStore.hasUnreadMsgs()) {
            <div class="badge-container">!</div>
            } @if (googleLoginService.isLoggedIn() &&
            storageService.hasLocalItem('avatar')) {
            <img #panelHolder class="avatar-img" [src]="avatar" alt="" />
            } @else {
            <div #panelHolder class="avatar-img login-account">
              {{ loginAccount.nickName?.charAt(0)?.toUpperCase() }}
            </div>
            }
            <span class="material-symbols-outlined">keyboard_arrow_down</span>
          </div>
        }
      <p-overlayPanel #op>
        <div class="panel-info flex flex-col" [class.smallSize]="isSmallSize">
          <div class="info login flex flex-row">
            @if (googleLoginService.isLoggedIn() &&
            storageService.hasLocalItem('avatar')) {
            <img #panelHolder class="avatar-img" [src]="avatar" alt="" />
            } @else {
            <div #panelHolder class="avatar-img login-account">
              {{ loginAccount.nickName?.charAt(0)?.toUpperCase() }}
            </div>
            }
  
            <div class="flex flex-col flex-wrap">
              <div class="panel-text">Welcome back,</div>
              <div class="panel-text panel-username">
                {{ loginAccount.nickName }}
              </div>
            </div>
          </div>
  
          <div class="actions login flex flex-col">
            <ng-container *ngFor="let slice of dropdownItemArrays">
              <div *ngFor="let action of slice" class="action flex items-center cursor-pointer"
                (click)="onButtonClick(action.leftIconName)" (click)="op.hide()">
                <span class="material-symbols-outlined" style="font-size: 17px">{{ action.leftIconName }}</span>
                <div class="action-label">{{ action.label }}</div>
                @if (action.label === 'Messages' && messageStore.hasUnreadMsgs()) {
                  <div class="menu-badge-container">
                    {{ messageStore.unreadMsgsCount() }}
                  </div>
                }
              </div>
              <hr class="divider slice-section" *ngIf="slice.length > 1" />
            </ng-container>
            <hr class="divider end-section" />
          </div>
          <ng-container *ngTemplateOutlet="myFooterBlock"></ng-container>
        </div>
      </p-overlayPanel>
      </div>
    } @else {
      <div>
        @if (isSmallSize) {
          <div class="menuBtn flex items-center justify-center" (click)="lp.toggle($event)">
            <span class="material-symbols-outlined">menu</span> 
          </div>
  
        } @else {
          <div class="flex flex-row items-center cursor-pointer" (click)="lp.toggle($event)">
            <div #panelHolder class="avatar-img login-account">
              <span class="material-symbols-outlined">perm_identity</span>
            </div>  
            <span class="material-symbols-outlined" >keyboard_arrow_down</span> 
          </div>
        }
      <p-overlayPanel #lp>
        <div class="panel-info flex flex-col" [class.smallSize]="isSmallSize">
          <div class="info flex flex-col">
            <button class="button-action-primary" type="button" (click)="onLogin()"> Log in
            </button>
            <small>
              Log in to view orders, messages, and manage your account.
            </small>
          </div>
  
          <div class="actions flex flex-col">
            <a [routerLink]="['',{ outlets: { primary: ['help-center'], mainBody: null } },]">
              <div class="action flex items-center cursor-pointer">
  
                <span class="material-symbols-outlined" style="font-size: 17px">{{ 'help' }}</span>
                <div class="action-label">Help center</div>
  
              </div>
            </a>
            <hr class="divider" />
          </div>
          <ng-container *ngTemplateOutlet="myFooterBlock"></ng-container>
        </div>
      </p-overlayPanel>
      </div>
    }
  </div>
</ng-template>
